import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-2x" }, "Vật tư ĐMCĐ")
], -1)
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, "Số lượng", -1)
const _hoisted_4 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_6 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex break-word align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Thành tiền")
], -1)
const _hoisted_8 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 break-word" }, "Đơn vị tính", -1)
const _hoisted_10 = { class: "d-flex align-items-center mb-0" }
const _hoisted_11 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_WordBreakColumn = _resolveComponent("WordBreakColumn")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isDialogDisplay,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDialogDisplay) = $event)),
    width: "70%",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('on-close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ButtonCustom, {
            "button-type": _ctx.ButtonsType.EDIT,
            "color-type": _ctx.ButtonTypeColors.SUCCESS,
            "tooltip-message": "chỉnh sửa",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.pushRouter({
              name: 'chi-tiet-dinh-muc-co-dinh',
              params: {
                id: _ctx.idDinhMuc,
              },
            })
          ))
          }, null, 8, ["button-type", "color-type"])
        ]),
        _createVNode(_component_el_table, {
          style: {"width":"100%"},
          size: "medium",
          "max-height": "800",
          "empty-text": "Không có dữ liệu",
          "cell-class-name": _ctx.isTextDangerColumn,
          border: true,
          data: _ctx.dataItems
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "ID",
              width: "50"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_WordBreakColumn, {
              "header-title": "Tên",
              property: "ten_vat_tu",
              width: "300"
            }),
            _createVNode(_component_el_table_column, {
              label: "Mã",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Thu hồi",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  value: _ctx.dataItems[scope.$index].thu_hoi,
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "C/ty quản lý" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  value: _ctx.dataItems[scope.$index].cong_ty_duyet,
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Trạng thái",
              width: "90"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, null, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.formatQuantity(scope.row.pivot.so_luong)), 1)
              ]),
              _: 1
            }),
            (_ctx.showDonGia)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "Đơn giá"
                }, {
                  header: _withCtx(() => [
                    _hoisted_5
                  ]),
                  default: _withCtx((scope) => [
                    _createElementVNode("p", _hoisted_6, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatUnitPrice(scope.row.don_gia)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showDonGia)
              ? (_openBlock(), _createBlock(_component_el_table_column, { key: 1 }, {
                  header: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx((scope) => [
                    _createElementVNode("p", _hoisted_8, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(
                    _ctx.calcLineAmount(
                      parseFloat(scope.row.don_gia),
                      scope.row.pivot.so_luong
                    )
                  )), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, { label: "ĐVT" }, {
              header: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.don_vi_tinh), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              width: "50",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_RouterLink, {
                    to: {
                  name: 'supply-detail',
                  params: { id: scope.row.id },
                },
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ButtonCustom, {
                        "button-type": _ctx.ButtonsType.INFO,
                        "color-type": _ctx.ButtonTypeColors.INFO,
                        "tooltip-message": "Chi tiết"
                      }, null, 8, ["button-type", "color-type"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cell-class-name", "data"])
      ])), [
        [_directive_dialog_auto_focus, _ctx.isDialogDisplay]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}